import moment from "moment";
import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import styled from "styled-components";
import { Utils } from "../../../utils";
import { MdOutlinePayments } from "react-icons/md";
import { FaCreditCard } from "react-icons/fa";

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
`;

const Left = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || "#0066cc"};
  color: gray;
  font-weight: bold;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const TextPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-weight: 600;
`;

const Description = styled.div`
  font-size: 13px;
  color: #444;
`;

const Tag = styled.span<{ status: string }>`
  display: inline-block;
  font-size: 10px;
  padding: 3px 6px;
  border-radius: 4px;
  background-color: ${({ status }) =>
    status === "approved"
      ? "#33865D"
      : status === "declined"
      ? "#F3B6BE"
      : status === "draft"
      ? "#FCD3A6"
      : "#e2e3e5"};
  color: ${({ status }) =>
    status === "approved"
      ? "#ffffff"
      : status === "declined"
      ? "#721c24"
      : status === "draft"
      ? "#856404"
      : "#383d41"};
  text-transform: capitalize;
  margin-top: 2px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: #777;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Amount = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: #333;
  margin-right: 1rem;
`;
const Dollar = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: 2px solid #999999;
  border-radius: 50%;

  img {
    width: 100%;
    object-fit: contain;
  }
`;

const CreatedAt = styled.div`
  font-size: .75rem;
  color: #999;
  font-style: italic;
  margin-top: 2px;
`;

type ExpenseCardProps = {
  data: {
    id: number;
    purchase_amount: number;
    description: string;
    spent_at: string;
    spent_on: string;
    status: string;
    is_reimbursable: boolean;
    employee: {
      name: string;
    };
  };
  bgColor?: string;
};

const ActionButton = styled.button<{ actionType?: "review" | "approve" | "rejected" | "pay" }>`
  color: ${({ actionType }) =>
    actionType === "pay" ? "#219150" : "#DC3545"};
  background-color: #ffffff;
  border: none;
  padding: 0.4rem 0.935rem;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  border: 1px solid
    ${({ actionType }) => 
      actionType === "pay" ? "#27ae60" : 
      actionType === "rejected" ? "#DC3545" : "#0066cc"};

  &:hover {
    background-color: ${({ actionType }) =>
      actionType === "pay" ? "#219150" : 
      actionType === "rejected" ? "#DC3545" : "#0066cc"};
    color: #ffffff;
  }
`;

const ExpenseCard: any = ({
  data, bgColor, onPay, showPay 
}:any) => {
  return (
    <Card>
      <Left>
        <Avatar bg={bgColor}>
          {data.employee?.name
            ?.split(" ")
            .map((n: any) => n?.[0])
            .join("")}
        </Avatar>
        <Dollar>
          <img src="/Pay Runs.svg" alt="Dollar Icon" />
        </Dollar>
        <TextPart>
          <InfoRow>
            <Title>{data.spent_at}</Title>
            <Description>"{data.description}"</Description>
            <Tag status={data.status}>{data.status}</Tag>
          </InfoRow>
          <Subtitle>
            {data.employee.name} ·{" "}
            {new Date(data.spent_on).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}{" "}
            · {data.is_reimbursable && "Reimbursable"}·{" "}
            {data.status === "declined" && (
              <span style={{ color: "#FF0000" }}>
                "Declined without reason"
              </span>
            )}
          </Subtitle>

          <CreatedAt>
            Created: {moment(data?.created_at).format("DD MMM YYYY, hh:mm A")}
          </CreatedAt>
        </TextPart>
      </Left>
      <Right>
        <Amount>{Utils.getCommanSepartedNumericStringWithDollar(data.purchase_amount)}</Amount>
        {showPay && <ActionButton actionType="pay" onClick={()=> onPay(data?.id)}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem",  }}>
            <FaCreditCard /> 
            <span> Pay </span>
          </div>
         </ActionButton>}
        {/* <BsThreeDotsVertical color="#999999" size={20} /> */}
      </Right>
    </Card>
  );
};

export default ExpenseCard;
